/** Per-provider config hints for the model / use-case config editors. */
export interface ProviderDocLinks {
  /** Provider model catalog (valid model IDs) — the one genuinely useful link. */
  models: string
  /** Common config keys (LangChain camelCase) shown inline as a hint. */
  commonParams: string[]
}

const PROVIDER_DOC_LINKS: Record<string, ProviderDocLinks> = {
  openai: {
    models: 'https://platform.openai.com/docs/models',
    commonParams: ['temperature', 'maxTokens', 'topP', 'frequencyPenalty', 'reasoningEffort'],
  },
  anthropic: {
    models: 'https://docs.anthropic.com/en/docs/about-claude/models/overview',
    commonParams: ['temperature', 'maxTokens', 'topP', 'topK'],
  },
  google: {
    models: 'https://ai.google.dev/gemini-api/docs/models',
    commonParams: ['temperature', 'maxOutputTokens', 'topP', 'topK', 'thinkingConfig'],
  },
}

export function getProviderDocLinks(providerName?: string): ProviderDocLinks | null {
  if (!providerName) return null
  return PROVIDER_DOC_LINKS[providerName] ?? null
}
